import { envSettings } from "core/EnvSettings";

export const isStorageModuleEnabled = (terminal) =>
	Boolean(envSettings.REACT_APP_FF_STORAGE_MODULE) && (terminal?.should_use_storage_module ?? true);
